import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { param } from 'jquery';
import { CommonService, regexPattern } from 'src/app/services/common.service';

@Component({
  selector: 'app-dynamicpopup',
  templateUrl: './dynamicpopup.component.html',
  styleUrls: ['./dynamicpopup.component.scss']
})
export class DynamicpopupComponent implements OnInit {
  Header: any;
  formdataCreatenewDoctypes: FormGroup;
  formdataCreatenewTenant: FormGroup;
  formdataCreatenewUser: FormGroup;
  formdataEditTenant: FormGroup;
  formdataEditUser: FormGroup;
  formdataEditDoctypes: FormGroup;
  formdataEditDocument: FormGroup;
  formtype: any;
  startDate = new Date();
  visibilityList: any = [];
  visibilityList1: any = [];
  binddocumnetypedata: any;
  bindvisibilitydata: any;
  bindtenantname: any;
  bindusername: any;
  bindeffectivefrom: any;
  bindeffectiveto: any;
  bindenable: any
  rowdatavalue: any = []
  constructor(public dialogRef: MatDialogRef<DynamicpopupComponent>, @Inject(MAT_DIALOG_DATA) public logParams: any, private fb: FormBuilder, private commonServ: CommonService) { }

  ngOnInit(): void {
    //console.log(this.logParams)
    this.fetchRoleedetails();
    this.fetchRoleedetailsuser();
    
    this.Header = this.logParams['header']
    this.formtype = this.logParams['type']
    if (this.logParams.hasOwnProperty('param')) {
      //console.log(this.logParams['param'])
      if (this.formtype == "editDocTypes") {
        this.editdoctypedata(this.logParams['param'])
      } else if (this.formtype == "editTenant") {
        this.edittenantdata(this.logParams['param'])
      } else if (this.formtype == "editdocumentdata") {
        this.editdocumentdata(this.logParams['param'])
      }
      else if (this.formtype == "editUser") {
        this.edituserdata(this.logParams['param'])
      }
    }
    if (this.logParams.hasOwnProperty('tabledata')) {
      this.rowdatavalue = this.logParams['tabledata']
      //console.log("doctype_data", this.rowdatavalue)
    }
    this.getdocumentvisbility()
    this.formdataCreatenewDoctypes = this.fb.group({
      document_type: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9 ]*')]),
      visibility_type: [''],

    })
    this.formdataEditDoctypes = this.fb.group({
      document_type: [''],
      visibility_type: [''],

    })
    this.formdataEditDocument = this.fb.group({
      attachmentFileName: [''],
      doc_id: [''],
      doc_name: [''],
      description: [''],
      tenant_id: [''],
      version: [''],
      enabled_flag: new FormControl(false),

    })
    this.formdataCreatenewTenant = new FormGroup({
      name: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9 ]*')]),
      username: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9&%#@ ]*')]),
      email_id_send: new FormControl('', [Validators.required, Validators.email]),
      role: new FormControl(''),
      effectiveForm: new FormControl(new Date()),
      effectiveTo: new FormControl(new Date()),
      tenantenableFlag: new FormControl(false),

    })
    this.tenant_name_deafult= ["CAPE"]
    this.formdataCreatenewUser = this.fb.group({
      name: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9 ]*')]),
      username: new FormControl('',[Validators.required,Validators.pattern('[a-zA-Z0-9&%#@ ]*')]),
      email_id_send: new FormControl('', [Validators.required, Validators.email]),
      role: [''],
      tenant:new FormControl(),
      effectiveForm: new FormControl(new Date()),
      effectiveTo: new FormControl(new Date()),
      userenableFlag: new FormControl(false),

    })
    this.formdataEditTenant = new FormGroup({
      name: new FormControl(''),
      username: new FormControl(''),
      email_id_send: new FormControl(''),
      role: new FormControl(''),
      effectiveForm: new FormControl(new Date()),
      effectiveTo: new FormControl(new Date()),
      tenantenableFlag: new FormControl(false),

    })
    this.formdataEditUser = new FormGroup({
      name: new FormControl(''),
      username: new FormControl(''),
      email_id_send: new FormControl(''),
      role: new FormControl(''),
      tenant: new FormControl(''),
      effectiveForm: new FormControl(new Date()),
      effectiveTo: new FormControl(new Date()),
      userenableFlag: new FormControl(false),

    })
    this.tenantdropdownuserdetails();
  }

  roledropdown: any = []
  roledropdown1: any = []
  roledropdown2: any = []

  fetchRoleedetails() {
    this.commonServ.fetchRoleedetails().subscribe((response) => {
      console.log("fetchRoleedetails", response)
      this.roledropdown = response;
      //this.roledropdown1 = this.roledropdown.slice()

      for (let i of response) {
        // if (i.role_id == 2) {
          this.roledropdown2.push(i);
        // }
      }

    })
    this.roledropdown1 = this.roledropdown2
    // console.log("test 11", this.roledropdown1)
    // console.log("test 22", this.roledropdown2)
  }
  roledropdownuser: any = []
  roledropdownuser1: any = []
  roledropdownuser2: any = []
  fetchRoleedetailsuser(){
    this.commonServ.fetchRoleedetailsuser().subscribe((response) => {
      console.log("fetchRoleedetails", response)
      this.roledropdownuser = response;
      //this.roledropdown1 = this.roledropdown.slice()

      for (let i of response) {
       
          this.roledropdownuser2.push(i);
        
      }

    })
    this.roledropdownuser1 = this.roledropdownuser2
  }


  tenantdropdownuser: any = []
  tenantdropdownuser1: any = []
  tenantdropdownuser2: any = []
  tenant_name_deafult: any;
  tenantdropdownuserdetails(){
    // this.formdataCreatenewUser.controls['tenant'].setValue("CAPE");

    this.tenant_name_deafult= ["CAPE"]
    this.commonServ.fetchTenantName().subscribe((response) => {
      console.log("fetchRoleedetails", response)
      this.tenantdropdownuser = response;
      //this.roledropdown1 = this.roledropdown.slice()

      for (let i of response) {
       
          this.tenantdropdownuser2.push(i);
        
      }

    })
    this.tenantdropdownuser1 = this.tenantdropdownuser2
  }

  getdocumentvisbility() {
    this.commonServ.fetchDocumentVisibility().subscribe((response) => {
      //console.log(response)
      this.visibilityList = response;
      this.visibilityList1 = this.visibilityList.slice();

    })
  }

  bindusernamerandom: any
  makeRandom() {
    let value = this.formdataCreatenewTenant.controls.name.value
    console.log("val", value)
    // let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]\=-)(*&^%$#@!~`";
    let possible = "1234567890&%#@"
    const lengthOfCode = 10;
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    }
    text = value + text;
    this.bindusernamerandom = text;
  }

  bindusernamerandomforUser: any
  makeRandomUser() {
    let value = this.formdataCreatenewUser.controls.name.value
    console.log("val", value)
    // let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]\=-)(*&^%$#@!~`";
    let possible = "1234567890&%#@"
    const lengthOfCode = 10;
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    }
    text = value + text;
    this.bindusernamerandomforUser = text;
  }

  onClickSubmitCreate(event) {
    // console.log("event", event)
    this.commonServ.InsertDoctypedata(event).subscribe((response) => {

    })


  }

  duplicateflag: boolean = false
  btnEnabled: boolean = true;
  onChangedocumenttype(event) {
    this.duplicateflag = false;
    // console.log("value", this.formdataCreatenewDoctypes.controls['document_type'].value)
    //console.log("event", event)
    //console.log("doctype_data", this.rowdatavalue)
    if (this.formdataCreatenewDoctypes.controls['document_type'].value == "") {
      this.btnEnabled = true;
    } else {
      this.btnEnabled = false;
    }
    for (let item of this.rowdatavalue) {
      if (item.lookup_code == this.formdataCreatenewDoctypes.controls['document_type'].value) {
        this.duplicateflag = true;
        this.btnEnabled = true;
        this.formdataCreatenewDoctypes.controls['document_type'].setErrors({ duplicateflag: true });
        break;
      }
    }
    //console.log("duplicateflag", this.duplicateflag)
  }

  editdoctypedata(param) {
    this.binddocumnetypedata = param['lookup_code']
    this.bindvisibilitydata = param['visibility']
  }
  doc_id: any;
  doc_version: any;
  doc_name: any;
  description: any;
  version: any;
  tenant_id: any;
  enabled_flag: any;
  editdocumentdata(param) {
    // console.log("param doc", param)
    this.doc_id = param['doc_id']
    this.description = param['doc_description']
    this.doc_name = param['doc_name']
    this.version = param['doc_version']
    this.enabled_flag = param['enabled_flag']
    this.tenant_id = param['tenant_id']
    // this.doc_id=param['doc_id']
  }
  bindemailidsend: any;
  bindroledetails: any;
  edittenantdata(param) {
    //console.log(param)
    this.bindtenantname = param['name']
    this.bindusername = param['user_name']
    this.bindemailidsend = param['email_id_sent']
    this.bindroledetails = param['role_name']
    //     let dateString = param['effective_start_date']
    // let [day, month, year] = dateString.split('/')
    // const dateObj = new Date(+year, +month - 1, +day)

    // console.log(dateObj)
    // console.log(new Date(dateObj))
    this.bindeffectivefrom = this.convertstringtodate(param['effective_start_date'])
    this.bindeffectiveto = this.convertstringtodate(param['effective_end_date'])
    // console.log(this.formdataEditTenant)
    // this.formdataEditTenant.controls['effectiveForm'].setValue(
    // vm.selectedUser.effective_start_date
    // new Date(param['effective_start_date'])
    // );
    this.bindenable = param['enabled_flag']
  }

  bindusernameuser:any;
  bindnameuser: any;
  bindemailiduser: any;
  bindroledetailsuser:any;
  bindeffectivefromuser:any;
  bindeffectivetouser:any;
  bindenableuser:any;
  editusertenantdata:any;
  edituserdata(param) {
    //console.log(param)
    this.bindusernameuser = param['name']
    this.bindnameuser = param['user_name']
    this.bindemailiduser = param['email_id_sent']
    this.bindroledetailsuser = param['role_name']
    if(param.hasOwnProperty('tenant_name')){
    this.editusertenantdata= param['tenant_name'].split(",")
    }
    //     let dateString = param['effective_start_date']
    // let [day, month, year] = dateString.split('/')
    // const dateObj = new Date(+year, +month - 1, +day)

    // console.log(dateObj)
    // console.log(new Date(dateObj))
    this.bindeffectivefromuser = this.convertstringtodate(param['effective_start_date'])
    this.bindeffectivetouser = this.convertstringtodate(param['effective_end_date'])
    // console.log(this.formdataEditTenant)
    // this.formdataEditTenant.controls['effectiveForm'].setValue(
    // vm.selectedUser.effective_start_date
    // new Date(param['effective_start_date'])
    // );
    this.bindenableuser = param['enabled_flag']
  }

  convertstringtodate(date) {
    let dateString = date
    let [day, month, year] = dateString.split('/')
    const dateObj = new Date(+year, +month - 1, +day)
    return dateObj
  }

  onClickSubmitupdate(event) {
    event['lookup_id'] = this.logParams['param']['lookup_id']
    //console.log("event", event)
    this.commonServ.updatedoctypedata(event).subscribe((response) => {

    })
  }
  makeRandompassword() {
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890*&%#@";
    const lengthOfCode = 10;
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }
  onClickSubmitcreatetenant(event) {
    // console.log("event", event)
    event['password'] = this.makeRandompassword();
    this.commonServ.insertTenantData(event).subscribe((response) => {

    })
  }

  onClickSubmitcreateuser(event) {
    // console.log("event", event)
    event['password'] = this.makeRandompassword();
    console.log("event", event)
    this.commonServ.insertUserData(event).subscribe((response) => {

    })
  }

  onClickSubmitedittenant(event) {
    event['tenant_id'] = this.logParams['param']['tenant_id']
    //console.log(event)
    this.commonServ.updatetenantdata(event).subscribe((response) => {

    })
  }

  onClickSubmitedituser(event) {
    event['user_id'] = this.logParams['param']['user_id']
    //console.log(event)
    this.commonServ.updateUserdata(event).subscribe((response) => {

    })
  }

  file: File
  fileName: any
  onFileChange(event) {
    //console.log("event", event)
    this.file = event.srcElement.files[0];
    var fileFormat = this.file.name.substr(this.file.name.lastIndexOf("."));
    var filename = event.srcElement.files[0].name.split(".")[0]
    //console.log("filename", filename)
    this.fileName = event.srcElement.files[0].name
    var fileExt = event.srcElement.files[0].name.split(".")[1]
    var fileSize = event.srcElement.files[0].size / 1024;

    var allowedTypes = ["txt", "doc", "docx", "pdf", "xls", "xlsx", "xlsb", "zip", "7z", "jpg", "jpeg", "odt", "ods", "csv"]
    // const specialChars = /[,'~@\\\\}{+)(*^%$£\"!\\|<>+]/;

    // if ($.inArray(fileExt.toLowerCase(), allowedTypes) !== -1 && fileSize > 0) {
    if (fileSize > 2000) {
      // if (this.page.create) {
      this.formdataEditDocument.controls['attachmentFileName'].setErrors({ size: true });
      // } else if (this.page.edit) {
      //   this.formdataEdit.controls['attachmentFileName'].setErrors({ size: true });
      // }
      // this._snackBar.open("File size exceeded. Maximum allowed size is 2 MB.", "Close")
    }
    // else if (specialChars.test(filename)) {
    else {
      if (regexPattern.alphanumericWithUnderscoreAndHyphen.test(filename)) {

      } else {
        // if (this.page.create) {
        this.formdataEditDocument.controls['attachmentFileName'].setErrors({ specialCharacters: true })
        // } else if (this.page.edit) {
        // this.formdataEdit.controls['attachmentFileName'].setErrors({ specialCharacters: true })
        // }
      }
    }
    // }
    // else {
    //   // if (this.page.create) {
    //     this.formdataCreate.controls['attachmentFileName'].setErrors({ format: true });
    //   // } else if (this.page.edit) {
    //   //   this.formdataEdit.controls['attachmentFileName'].setErrors({ format: true });
    //   // }

    // }
  }

  onClickSubmiteditdocumentdata(event: any) {
    //console.log("event", event)

    event['fileName'] = this.fileName;

    //console.log(this.file)
    //console.log("event", event)

    this.commonServ.updatedoc(event, this.file).subscribe((response) => {



    })
  }

}
